import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree,
} from '@angular/router';

import { FsMessage, MessageMode } from '@firestitch/message';

import { SessionService, SigninService } from '@app/core';

import { Account } from '../interfaces';


@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _sessionService: SessionService,
    private _message: FsMessage,
    private _signinService: SigninService,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this._signinService.signedIn()) {
      this._message.error('Your session has expired. Please signin again.',
        { mode: MessageMode.Toast });

      return this.createSigninUrlTree();
    }

    const account: Account = this._sessionService.account();

    if (account && account.passwordChange) {
      this._router.navigate(['/passwordchange'], { queryParams: { redirect: state.url } });

      return false;
    }

    return true;
  }

  public createSigninUrlTree(): UrlTree {
    const redirect = window.location.pathname + window.location.search;

    return this._router.createUrlTree(['/signin'],
      { queryParams: { redirect } });
  }

}
